import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import CreateUser from "../../components/CreateUser";

const CreateUserScreen = (props) => {
  return (
    <HeaderDrawer name="Cadastrar novo usuário">
      <CreateUser
        onRequestSend={(values) => props.createUser(values)}
        {...props}
      />
    </HeaderDrawer>
  );
};

export default CreateUserScreen;
